var _desc, _path, _path2, _circle, _circle2, _circle3, _path3, _circle4, _circle5, _circle6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSodaGlass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Soda Glass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51.1 28l.9-10H20l.9 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M12 2h6.5c1.6 0 6.8.9 7.5 6s4 48 4 48",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 45,
    cy: 5,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 46,
    cy: 12,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 35,
    cy: 9,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.9 28L24 62h24l3.1-34H20.9z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 45,
    cy: 5,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 46,
    cy: 12,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "layer1",
    cx: 35,
    cy: 9,
    r: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodaGlass);
export default __webpack_public_path__ + "static/media/soda-glass.7592c539.svg";
export { ForwardRef as ReactComponent };